import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from './api/config';

function DeleteMyAccount() {
    
  const [values, setValues] = useState({ email: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  axios.defaults.withCredentials = true;

  const handleSendCode = (e) => {
    e.preventDefault();
    setLoading(true);  

    axios.post(`${API_URL}/send-delete-my-account-code-api`, {
      email: values.email
    })
      .then(res => {
        if (res.data.Status === "Success") {
          toast.success("Code sent to your email", { position: "top-right", autoClose: 3000 });
        } else {
          toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
        }
      })
      .catch(() => {
        toast.error("An error occurred. Please try again.", { position: "top-right", autoClose: 3000 });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center" >
      <ToastContainer />
      <div className="container" style={{ maxWidth: '600px', padding: '1rem' }}>
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-6" style={{ width: '100%' }}>
            <div className="bg-med-green text-white p-0 rounded" style={{
              background: '#ffffff',
              borderRadius: '28px',
              overflow: 'hidden',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
            }}>
              <div className="card-body text-center" style={{ padding: 0 }}>
                
                {/* Header with brand colors */}
                <div style={{
                  background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
                  padding: '2rem 2rem 1.5rem 2rem',
                  borderBottom: '1px solid rgba(255,255,255,0.1)'
                }}>
                  <div className="py-3" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                    <img src="img/logo_1.png" alt="Oret Africa" height="48" style={{ filter: 'brightness(0) invert(1)' }} />
                  </div>
                  <h3 style={{
                    fontFamily: "'Playfair Display', serif",
                    fontSize: '1.75rem',
                    fontWeight: '600',
                    marginTop: '0.5rem',
                    marginBottom: '0',
                    color: '#ffffff'
                  }}>Delete Account</h3>
                  <p style={{
                    fontSize: '0.85rem',
                    opacity: 0.9,
                    marginTop: '0.5rem',
                    marginBottom: '0',
                    color: '#e0f0e5'
                  }}>This action is permanent</p>
                </div>

                <form onSubmit={handleSendCode} style={{ padding: '2rem' }}>
                  <div className="row g-4">
                    
                    {/* Info message box */}
                    <div className='col-12'>
                      <div style={{
                        background: '#fef3e8',
                        borderLeft: '4px solid #ff6600',
                        borderRadius: '12px',
                        padding: '1rem',
                        marginBottom: '0.5rem',
                        textAlign: 'left'
                      }}>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                          <span style={{ fontSize: '1.2rem' }}>⚠️</span>
                          <div>
                            <p style={{ 
                              margin: 0, 
                              color: '#5a3a1a', 
                              fontSize: '0.9rem', 
                              fontWeight: '500',
                              lineHeight: '1.5'
                            }}>
                              You can login to your account and navigate to <strong>Account → Settings</strong> to delete your account
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* OR divider */}
                    <div className='col-12'>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px',
                        margin: '0.5rem 0'
                      }}>
                        <div style={{ flex: 1, height: '1px', background: '#e5ede8' }}></div>
                        <span style={{
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          textTransform: 'uppercase',
                          letterSpacing: '1px',
                          color: '#7c9b86',
                          background: '#ffffff',
                          padding: '0 12px'
                        }}>OR</span>
                        <div style={{ flex: 1, height: '1px', background: '#e5ede8' }}></div>
                      </div>
                    </div>

                    {/* Email instruction */}
                    <div className='col-12'>
                      <p style={{
                        color: '#2c5e3a',
                        fontSize: '0.9rem',
                        marginBottom: '0.5rem',
                        textAlign: 'center',
                        fontWeight: '500'
                      }}>
                        Enter your email address below to receive verification code
                      </p>
                    </div>

                    {/* Email input */}
                    <div className="col-12">
                      <label style={{
                        display: 'block',
                        textAlign: 'left',
                        fontWeight: '600',
                        color: '#1a3a24',
                        fontSize: '0.85rem',
                        marginBottom: '0.5rem',
                        letterSpacing: '-0.2px'
                      }}>
                        <i className="fas fa-envelope" style={{ marginRight: '8px', fontSize: '0.8rem' }}></i>
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="your@email.com"
                        onChange={e => setValues({ ...values, email: e.target.value })}
                        required
                        style={{
                          border: '2px solid #e1ebe3',
                          borderRadius: '14px',
                          padding: '0.85rem 1rem',
                          fontSize: '0.95rem',
                          transition: 'all 0.2s ease',
                          fontFamily: "'DM Sans', sans-serif"
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#0d6e28'}
                        onBlur={(e) => e.target.style.borderColor = '#e1ebe3'}
                      />
                    </div>

                    {/* Submit button */}
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                        style={{
                          background: loading ? '#c0cfc5' : '#ff6600',
                          border: 'none',
                          borderRadius: '40px',
                          padding: '0.9rem 1rem',
                          fontWeight: '600',
                          fontSize: '0.95rem',
                          letterSpacing: '0.3px',
                          transition: 'all 0.2s ease',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          color: '#ffffff'
                        }}
                        onMouseEnter={(e) => {
                          if (!loading) e.target.style.background = '#e55a00';
                        }}
                        onMouseLeave={(e) => {
                          if (!loading) e.target.style.background = '#ff6600';
                        }}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-paper-plane me-2"></i>
                            Confirm with email
                          </>
                        )}
                      </button>
                    </div>

                    {/* Security note */}
                    
                    

                  </div>
                </form>

                {/* Footer */}
                <div style={{
                  borderTop: '1px solid #e5ede8',
                  padding: '1rem 2rem',
                  background: '#fafdfb'
                }}>
                  <p style={{
                    fontSize: '0.7rem',
                    color: '#8aa899',
                    margin: 0,
                    textAlign: 'center'
                  }}>
                    <i className="fas fa-question-circle me-1"></i>
                    Need help? Contact <strong style={{ color: '#0d6e28' }}>support@oret.africa</strong>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteMyAccount;